<template>
  <generic-modal :title="$t('assign')" ref="generic_modal">
    <form>
      <div class="field">
        <generic-dropdown
          :title="$t('user')"
          :placeholder="$t('select one')"
          url="/access/user/catalog"
          name_field="username"
          value_field="user_id"
          @selected="set_user"
          ref="user_dropdown"
          :is_multiple="false"
        />
      </div>
      <table class="table is-striped is-hoverable is-fullwidth">
        <thead>
          <tr>
            <th>{{ $t("customer") }}</th>
            <th>{{ $t("email") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(customer, index) in meta.customer_list" :key="index">
            <td>{{ customer.shipper_name }}</td>
            <td>{{ customer.email }}</td>
          </tr>
        </tbody>
      </table>
      <!-- <pre>{{ meta.customer_list }}</pre> -->
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-envelope"></i>
        </span>
        <span>{{ $t("send") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "AssignModal",
  components: { GenericModal, GenericDropdown },
  data() {
    return {
      meta: {
        customer_list: [],
        user_id: "",
      },
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.user_id;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show(customer_list) {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
      v.meta.customer_list = customer_list;
    },
    save() {
      let v = this;
      post("/central-dispatch-tracker/service/assign", v.meta)
        .then(() => {
          v.$emit("success");
          v.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        customer_list: [],
        settings: {},
      };
      v.$refs.user_dropdown.clear();
      v.error = "";
      // v.uuid = "";
    },
    set_user(user) {
      let v = this;
      if (user) v.meta.user_id = user.user_id;
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
